import { render, staticRenderFns } from "./TranslationMap.vue?vue&type=template&id=59fb5509&scoped=true&"
var script = {}
import style0 from "./TranslationMap.vue?vue&type=style&index=0&id=59fb5509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fb5509",
  null
  
)

export default component.exports